// extracted by mini-css-extract-plugin
export default {"hooks":"Hooks_hooks__Inr-h","hookItem":"Hooks_hookItem__h86bh"};